import Counter from "./Counter";
import Reveal from "./Reveal";
import { STATS } from "../lib/data";

export default function StatsBand() {
  return (
    <section
      data-testid="stats-band"
      className="relative overflow-hidden bg-navy text-white"
    >
      <div className="grain" />
      <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-2 gap-y-12 px-6 py-20 lg:grid-cols-4 lg:px-8">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i}>
            <div className="border-l border-white/15 pl-6">
              <div className="font-display text-5xl font-extrabold tracking-tight text-white lg:text-6xl">
                {s.value !== null ? (
                  <Counter target={s.value} suffix={s.suffix} />
                ) : (
                  s.display
                )}
              </div>
              <p className="mt-3 text-sm uppercase tracking-widest text-white/50">
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
